import React, { FC } from "react";
import { Paragraph, ParagraphProps } from "theme-ui";

export const PriceText: FC<ParagraphProps> = ({
  children,
  ...props
}: ParagraphProps) => (
  <Paragraph variant="table.priceText" {...props}>
    {children}
  </Paragraph>
);
